import { setInitialPayment } from 'src/utils/contracts';
import { removesScientificNotationFromNumber } from 'src/utils/formatAmout';
import { PaymentInputOption } from 'src/utils/constants/quotes';

export default values => ({
  ...values,
  rate: values.rate ? removesScientificNotationFromNumber(values.rate) : null,
  initialPaymentPorcentaje: values.initialPaymentPorcentaje || null,
  term: values.term || null,
  equipmentCost: values.equipmentCost || null,
  initialPayment: setInitialPayment(values),
  netInvestment: values.netInvestment || 0,
  rent: values.rent || 0,
  residualPayment: values.residualPayment || 1,
  enableMsi: values.enableMsi || false,
  msiDiscountPercentage: values.discountPercentage || 0,
  msiDiscountAmount: values.discountAmount || 0,
  isFirstUpfrontRentModality: values.isFirstUpfrontRentModality || false,
  insurance: values.insurance || 0,
  isInsuranceIncluded: values.isInsuranceIncluded || false,
  paymentInputOption: values.paymentInputOption || PaymentInputOption.AMOUNT
});
